export const enum CategoryDictionaryEnum {
    LOCAL = 'local',
    COMMON = 'common',
}